import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type FeatureColorPriceClasses = 'price' | 'included';

const featureColorPriceStyles = makeStyles<ISpcTheme, FeatureColorPriceClasses>(
  ({ palette }) => ({
    price: {},
    included: {
      color: palette.primary.main,
    },
  }),
  { name: 'GqlCustomise_Feature_ColorPrice' },
);

export default featureColorPriceStyles;
